<template>
  <ion-footer>
      <ion-toolbar class="footer">
        <MenuMain/>
      </ion-toolbar>
  </ion-footer>
</template>

<script>
import MenuMain from './menu/MenuMain'


export default {
  name: "Footer",
  components:{
    MenuMain
  },
  data(){
    return {
    }
  }
}
</script>

<style>

</style>